import { AbstractView } from "../../../../../abstracts/modules/AbstractView";
import { DDDSoundNames } from "../../../../assetsLoader/DDDAssetsNames";
import { DDDFreespinRestoreScreen } from "../freespin/DDDFreespinRestoreScreen";

export class DDDSuperFreespinRestoreScreen extends DDDFreespinRestoreScreen {
    constructor(parentContainer: AbstractView) {
        super(parentContainer, `DDDSuperFreespinRestoreScreen`);
    }

    protected override getTweenName(): string {
        return `deaderspinintro`;
    }

    protected getIntroStartSoundName(): string {
        return DDDSoundNames.SFS_INTRO_START;
    }

    protected getIntroLoopSoundName(): string {
        return DDDSoundNames.SFS_INTRO_LOOP;
    }
}
